import React, { useState, useEffect } from 'react';

const Modal = ({ handleClose, show, children }) => {
  const [isClosed, setIsClosed] = useState(false);
  const showHideClassName = show ? "modal display-block" : "modal display-none";
  const modalCloseClass = isClosed ? "modal-close-text closed" : "modal-close-text";

  useEffect(() => {
    const handleDocumentClick = () => {
      setIsClosed(true);
      handleClose();
    };
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [handleClose]);

  if (!isClosed) {
    return (
      <div className={showHideClassName}>
        <section className="modal-main">
          {children}
          <div className={modalCloseClass}>&#8592; swipe &#8594;</div>
        </section>
      </div>
    );
  } else {
    return null;
  }
};

export default Modal;
